<template lang="html">
  <div id="home" class="home--view home">
    <intro></intro>

    <section class="excelencia">
      <div class="container-img">
        <picture>
          <source media="(max-width: 900px)" srcset="/static/img/responsive/home/home-ajusa-sede.webp">
          <img
          class="back-image"
          src="/static/img/home/home-ajusa-sede.webp"
          :alt="$t('home.alt_images.fabricante')" width="1920" height="1274" />
        </picture>
        <div class="container">
          <div class="pad-sec container-text waypoints" data="fadeInUp">
            <h2 class="title title-36" v-html="$t('home.intro.titulo')"></h2>
            <p v-html="$t('home.intro.texto', { link: $t('enlaces.catalogo') })"></p>
          </div>
        </div>
      </div>
    </section>

    <section class="calidad">
      <article class="calidad-1">
        <div class="container">
          <div>
            <h2 class="title">
              <span
                class="first bold title-114 waypoints"
                v-html="$t('home.calidad.titulo.first')"
              ></span>
              <span
                class="second waypoints"
                v-html="$t('home.calidad.titulo.second')"
              ></span>
              <span
                class="third waypoints"
                v-html="$t('home.calidad.titulo.third')"
              ></span>
              <span
                class="fourth waypoints"
                v-html="$t('home.calidad.titulo.fourth')"
              ></span>
            </h2>
          </div>
          <div class="down flex wrap justify-center">
            <img
              alt=""
              src="/static/img/flecha_blanca.svg"
              style="width: 100%; height: 50px;" width="12" height="34" loading="lazy" />
          </div>
          <div class="flex justify-end column align-end app-container">
            <p
              :class="this.getLanguage === 'us' ? 'calidad-1-text' : ''"
              v-html="$t('home.calidad.texto')"
            ></p>
            <div class="app-mobile-home">
              <h2>{{ $t("home.ajusa_app.title") }}</h2>
              <picture>
                <source media="(max-width: 900px)" srcset="/static/img/responsive/mobile-ajusa.webp">
                <img
                src="/static/img/mobile-ajusa.webp"
                :alt="$t('home.alt_images.mobile_app')" width="800" height="643" loading="lazy" />
              </picture>
            </div>
            <p
              v-if="this.getLanguage === 'us'"
              v-html="$t('home.ajusa_app.text')"
            />
            <div class="btn-app-mobile">
              <a
                class="btn"
                href="https://apps.apple.com/es/app/ajusa-mobile/id1428469914"
                target="_blank"
                >IOS</a
              >
              <a
                class="btn"
                :href="
                  'https://play.google.com/store/apps/details?id=com.ajusa.app&hl=' +
                    $i18n.locale
                "
                target="_blank"
                >ANDROID</a
              >
            </div>
          </div>
        </div>
        <div class="scrollme pieza-1 waypoints" data="fadeInUp">
          <picture>
            <source media="(max-width: 900px)" srcset="/static/img/responsive/home/pieza-1.webp">
            <img
            class="animateme"
            src="/static/img/home/pieza-1.webp"
            :alt="$t('home.alt_images.junta_culata')" width="1500" height="1201" loading="lazy" />
          </picture>
        </div>
      </article>

      <article class="calidad-2">
        <div class="flex wrap justify-center">
          <div
            class="superponer flex column justify-start waypoints"
            data="fadeInLeft"
          >
            <div class="margin-p">
              <p v-html="$t('home.calidad_2.texto_1')"></p>
              <router-link class="link" :to="$t('sobre_nosotros.nav_options.trabaja_con_nosotros.href')"> 
                  {{ $t('sobre_nosotros.nav_options.trabaja_con_nosotros.title') }}
              </router-link>
            </div>
            <div class="scrollme pieza-2 waypoints" data="fadeInUp">
              <picture>
                <source media="(max-width: 900px)" srcset="/static/img/responsive/home/pieza-2.webp">
                <img
                class="animateme"
                src="/static/img/home/pieza-2.webp"
                :alt="$t('home.alt_images.tubos_engrase')" width="1554" height="681" loading="lazy" />
              </picture>
            </div>
          </div>
          <div
            class="blue-block pad-art flex column justify-center waypoints"
            data="fadeInRight"
          >
            <p v-html="$t('home.calidad_2.texto_2')"></p>
            <p
              v-if="this.getLanguage === 'us'"
              v-html="$t('home.calidad_2.texto_3')"
            ></p>
            <div class="scrollme pieza-3 waypoints" data="fadeInUp">
              <picture>
                <source media="(max-width: 900px)" srcset="/static/img/responsive/home/pieza-3.webp">
                <img
                class="animateme"
                src="/static/img/home/pieza-3.webp"
                :alt="$t('home.alt_images.junta_motor')" width="1000" height="589" loading="lazy" />
              </picture>
            </div>
          </div>
        </div>
      </article>

      <article
        class="calidad-3 flex row-reserve wrap justify-start align-strech"
      >
        <div
          class="bkg-metal col-50 pad-art flex column justify-center align-end"
        >
          <div v-html="$t('home.calidad_3.titulo')"></div>
        </div>
        <div class="col-50 pad-art flex column justify-end">
          <p v-html="$t('home.calidad_3.texto', { link: $t('enlaces.contacto') })">
          </p>
        </div>
      </article>
    </section>

    <section class="ver-productos pad-sec">
      <router-link :to="$t('enlaces.productos')"></router-link>
      <div class="container waypoints" data="fadeInUp">
        <div v-html="$t('home.productos.titulo')"></div>
        <p
          v-if="this.getLanguage === 'us'"
          v-html="$t('home.productos.text')"
        ></p>
        <div class="mas-light"></div>
      </div>
    </section>

    <destacados></destacados>
    <poup-vehiculo></poup-vehiculo>
  </div>
</template>

<script lang="js">
import Intro from '@/components/view-parts/intros/home'
import Destacados from '@/components/view-parts/home/destacados'
import PopupVehiculo from '@/components/parts/popup-vehiculo-electrico'

import { mapGetters } from 'vuex';

export default  {
  name: 'home',
  components: {
    'intro' : Intro,
    'destacados' : Destacados,
    'poup-vehiculo': PopupVehiculo
  },
  mounted(){
    if(this.$route.path == "/newsletter"){
      $("html, body").animate({scrollTop:6000}, '500');
    }
    // El intercambio de imagenes por la version reducida lo hace ahora el
    // atributo `srcset` de cada <img>. Antes se sustituia aqui el `src`, ya
    // renderizada la pagina, de modo que el navegador habia empezado a
    // descargar la version grande y en movil se descargaban las dos.
  },
  computed: {
    ...mapGetters(['getLanguage']),
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/home.vue